export default "__VITE_ASSET__CeF63b8Y__"